import __request__ from "routing/request";
export function aggregateSearchRequestSpec(searchRequestSpec) {
  return __request__("POST", "/search/aggregate", searchRequestSpec, {}, {
    "Accept": []
  });
}
export function aggregateForQueryParameters(query, streams, stream_categories, timerange, groups, metrics) {
  return __request__("GET", "/search/aggregate", null, { "query": query, "streams": streams, "stream_categories": stream_categories, "timerange": timerange, "groups": groups, "metrics": metrics }, {
    "Accept": []
  });
}
export function messagesByQueryRequestSpec(queryRequestSpec) {
  return __request__("POST", "/search/messages", queryRequestSpec, {}, {
    "Accept": []
  });
}
export function messagesByQueryParameters(query, timerange, streams, stream_categories, fields, sort, sortOrder, from, size) {
  return __request__("GET", "/search/messages", streams, { "query": query, "stream_categories": stream_categories, "timerange": timerange, "fields": fields, "sort": sort, "sortOrder": sortOrder, "from": from, "size": size }, {
    "Accept": []
  });
}
